import Link from "next/link";

const ShopInShopNavbar = ({ menu }) => (
  <menu className="flex text-[12px] gap-[30px] container">
    {menu.map((menuItem, index) => (
      <li
        key={index}
        className="text-white min-w-fit hover:text-[#FFCB05] border-b border-transparent hover:border-[#FFCB05]"
      >
        <Link href={menuItem.url}>
          <a title={menuItem.name} className="block">
            {menuItem.name}
          </a>
        </Link>
      </li>
    ))}
  </menu>
);

export default ShopInShopNavbar;
